import React, { useEffect, useRef, useState } from 'react';
import { SketchPicker } from 'react-color';
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PaletteIcon from '@mui/icons-material/Palette';
import Slide from '@mui/material/Slide';
import 'react-image-crop/dist/ReactCrop.css';
import Modal from '@mui/material/Modal';

import ImageEditor from '../../common/ImageCropModal';
import { translate } from '../../helper';
import lock from '../../assets/image/svg/lock_person.svg';
import Switch from '../../common/CustomRadioButton';
import { useSelector } from 'react-redux';
import LocalStorage from '../../defined/localStorage';
import './style.css';
import { resolveCssVarValue } from '../../utils/CommonFunction';
import { ENV } from '../../Env';
import CustomSpinner from '../../common/CustomSpinner';

const brand = JSON.parse(LocalStorage.getItem('branding'));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SubHeader(props) {
  const { label, button, hyperlinkText, onClick, loading = false } = props;
  const whiteLabel = useSelector((state) => state.User?.branding);
  return (
    <div
      style={{
        display: 'inline-grid',
        alignItems: 'center',
        gridTemplateColumns: 'auto 1fr auto',
        width: '100%'
      }}>
      {label && (
        <span
          style={{
            fontSize: 'calc(var(--fs-xs)*1.698113)',
            width: 'fit-content',
            lineHeight: 'calc(var(--sp-lg)*1.273585)',
            fontWeight: '600',
            padding: 'calc(var(--sp-md2)*1) calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1) 0'
          }}>
          {translate(label)}
        </span>
      )}
      <div style={{ 
          height: "calc(var(--fs-xs)*0.13650)", 
          background: 'linear-gradient(90deg, rgba(229, 231, 235, 0) 0%, rgba(26, 90, 120, 0.6) 25%, rgba(26, 90, 120, 1) 50%, rgba(26, 90, 120, 0.6) 75%, rgba(229, 231, 235, 0) 100%)',
          borderRadius: 'calc(var(--sp-md2)*0.5)',
          boxShadow: '0 4px 12px rgba(26, 90, 120, 0.15), 0 2px 6px rgba(26, 90, 120, 0.08)',
          marginLeft: 'calc(var(--sp-md2)*1)'
        }}/>
      {button && (
        <button
          style={{
            borderRadius: 'calc(var(--sp-xxs)*2)',
            padding: 'calc(var(--sp-md2)*1) calc(var(--sp-md2)*1.88679)',
            marginLeft: 'calc(var(--sp-md2)*1.88679)',
            border: 'none',
            background: `${
              whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)'
            }`,
            boxShadow: '0px 4px 4px 0px rgba(185, 131, 9, 0.09)',
            fontWeight: '700',
            fontSize: 'calc(var(--fs-xs)*1.32075)',
            color: '#fff',
            textTransform: 'uppercase',
            width: 'fit-content',
            cursor: 'pointer',
            minWidth: 'calc(var(--fs-hero)*3.679245)'
          }}
          onClick={() => {
            onClick && !loading && onClick();
          }}>
          {loading ? (
            <CustomSpinner
              size={resolveCssVarValue('--fs-xs') * 1.415094}
              style={{ marginRight: 'calc(var(--sp-xs)*1)' }}
            />
          ) : (
            translate(button)
          )}
        </button>
      )}
      {hyperlinkText && (
        <button
          style={{
            borderRadius: 'calc(var(--sp-xxs)*2)',
            padding: 'calc(var(--sp-md2)*1) calc(var(--sp-md2)*1.88679)',
            marginLeft: 'calc(var(--sp-md2)*1.88679)',
            border: 'none',
            background: '#fff',
            fontWeight: '700',
            fontSize: 'calc(var(--fs-xs)*1.32075)',
            color: 'rgba(248, 178, 24, 1)',
            textTransform: 'capitalize',
            width: 'fit-content'
          }}>
          {translate(hyperlinkText)}
        </button>
      )}
    </div>
  );
}

const defaultColor = { r: '0', g: '0', b: '0', a: '1' };

function ThemeDesign({
  header,
  topBanner,
  sideBanner,
  background,
  button,
  onSubmit,
  sideBannerColor = defaultColor,
  topBannerColor,
  backgroundColor,
  buttonColor,
  logo,
  setSideBannerColor,
  setTopBannerColor,
  setBackgroundColor,
  setButtonColor,
  setLogo,
  onCancel,
  active,
  setActive,
  logoError,
  setLogoError,
  loading,
  send,
  onPreview,
  isSending
}) {
  const whiteLabel = useSelector((state) => state.User?.branding);
  const { user = {} } = useSelector((state) => state.User?.userInfo);

  const [error, setError] = useState('');
  const [cancelLoading, setCancelLoading] = useState(false);
  const [clearedNotes, setClearedNotes] = useState('');
  const [open, setOpen] = useState(false);
  const [previewImg, setPreviewImg] = useState();
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [logoImage, setLogoImage] = useState(null);
  const fileInputRef = useRef(null);
  let disable = ENV.CURRENT_DOMAIN === ENV.MAIN_DOMAIN_URL;
  const handleCancel = () => {
    setCancelLoading(true);
    setTimeout(() => {
      setCancelLoading(false);
      onCancel();
    }, 500);
  };

  useState(() => {
    if (!cancelLoading) {
      setClearedNotes('cleared!!!');
      setTimeout(() => {
        setClearedNotes('');
      }, 500);
    }
  }, [cancelLoading]);

  const { r, g, b, a } = sideBannerColor;
  const { r: r1, g: g1, b: b1, a: a1 } = topBannerColor;
  const { r: r2, g: g2, b: b2, a: a2 } = backgroundColor;
  const { r: r3, g: g3, b: b3, a: a3 } = buttonColor;

  function complement(r, g, b) {
    const m = 255;
    return `${Math.abs(m - r)}, ${Math.abs(m - g)}, ${Math.abs(m - b)}`;
  }

  const onFileUpload = (e) => {
    setError('');
    setLogoError('');
    const file = e.target.files[0];

    const re = /(\.jpg|\.jpeg|\.gif|\.png)$/i;
    if (!re.exec(file.name)) {
      setError('File extension not supported!');
      return;
    }
    setLogoImage(file);
    setIsEditorOpen(true);
  };

  const handlePreviewImg = () => {
    if (!logo) {
      return;
    }
    setPreviewImg(logo);
    setTimeout(() => {
      setOpen(true);
    }, 100);
  };

  const handleClose = () => {
    setOpen(false);
    setPreviewImg();
  };

  function imageUrl(url) {
    if (url?.type) {
      return URL.createObjectURL(url);
    }
    return url;
  }

  const handleCloseEditor = () => {
    setIsEditorOpen(false);
    let input = document.getElementById('logo-upload');
    if (input) {
      input.value = '';
    }
    fileInputRef.current.value = '';

    setLogoImage(null);
  };

  useEffect(() => {
    if (logoImage) {
      setIsEditorOpen(true);
    }
  }, [logoImage]);

  const handleCroppedImage = (img) => {
    let arr = img.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    let file = new File([u8arr], logoImage.name, { type: mime });
    setLogo(file);
    handleCloseEditor();
  };

  return (
    <div style={{ width: '100%' }}>
      <SubHeader
        label="logoCustomization"
        // button={header&&"sendSetupLink"} commented by Krishna Kumar (Finoit) - MOV-4
        onClick={send}
        loading={isSending}
      />
      {header && user?.role === 'White Label Partner Admin' && (
        <div
          style={{
            width: '100%',
            margin: 'calc(var(--sp-md2)*1.886792) 0',
            borderRadius: 'var(--sp-sm)',
            backgroundColor: '#FBF4E6',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
          <div>
            <img
              src={lock}
              style={{
                width: 'calc(var(--fs-xs)*1.698113)',
                height: 'calc(var(--fs-xs)*1.698113)',
                marginRight: 'var(--sp-sm)',
                marginLeft: 'var(--sp-sm)'
              }}
            />
            <span
              style={{
                fontWeight: '400',
                color: '#4F4F4F',
                fontSize: 'calc(var(--fs-xs)*1.32075)',
                lineHeight: 'var(--sp-lg)'
              }}>
              {translate('lockBranding')}
            </span>
          </div>
          <FormControlLabel
            onChange={({ target: { checked } }) => setActive(checked)}
            control={<Switch checked={active} sx={{ m: 1 }} />}
          />
        </div>
      )}
      <div
        style={{
          borderRadius: 'calc(var(--sp-md2)*1)',
          marginTop: 'calc(var(--sp-md2)*1.886792)',
          marginBottom: 'calc(var(--sp-md2)*2.5)',
          display: 'flex',
          flexDirection: 'column'
        }}>
        <span
          style={{
            fontSize: 'calc(var(--fs-xs)*1.4150943)',
            fontWeight: '600',
            lineHeight: 'calc(var(--sp-md2)*1.509433)',
            color: '#4F4F4F',
            margin: 'calc(var(--sp-md2)*0) 0 calc(var(--sp-md2)*1) 0',
            letterSpacing: '0.5px'
          }}>
          {translate('logoSize')}
        </span>
        <div
          style={{
            width: 'calc(var(--fs-hero)*7.07547)',
            height: 'calc(var(--fs-hero)*2.830188)',
            borderRadius: 'calc(var(--sp-xxs)*1.5)',
            background: 'linear-gradient(135deg, #ffffff 0%, #ffffff 100%)',
            border: '2px solid',
            borderImage: 'linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%) 1',
            margin: 'calc(var(--sp-md2)*1) 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#fff',
            boxShadow: `0 0 0 1px rgba(255,255,255,0.8) inset, 
                        0 4px 6px rgba(0,0,0,0.05), 
                        0 10px 30px rgba(0,0,0,0.12),
                        0 0 20px rgba(248,178,24,0.08)`,
            transition: 'all 0.3s ease'
          }}>
          {logo && (
            <img
              src={imageUrl(logo)}
              alt="logo"
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              accept="image/png, image/jpg, image/gif"
            />
          )}
        </div>
        <span
          style={{
            fontSize: 'calc(var(--fs-xs)*1.132075)',
            fontWeight: '400',
            lineHeight: 'var(--sp-lg)',
            color: '#4F4F4F',
            margin: 'calc(var(--sp-md2)*1) 0',
            letterSpacing: '0.2px'
          }}>
          {translate('imageFileSupport')}
        </span>
        {/* <span
                    style={{
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "var(--sp-lg)",
                        color: "#FF0000",
                        margin: "10px 0"
                    }}
                >
                    {translate('uploadImageSizeWarning')}
                </span> */}
        {(error.length > 0 || logoError.length > 0) && (
          <p
            style={{
              fontSize: 'calc(var(--fs-xs)*1.132075)',
              fontWeight: '400',
              lineHeight: 'var(--sp-lg)',
              color: '#FFB3B3',
              margin: 'calc(var(--sp-md2)*1) 0'
            }}>
            {error.length > 0 ? error : logoError}
          </p>
        )}
        <div
          style={{
            width: 'calc(var(--fs-hero)*7.07547)',
            height: 'calc(var(--fs-xl)*1.226415)',
            margin: 'calc(var(--sp-md2)*1) 0',
            display: 'flex',
            justifyContent: 'space-between'
          }}>
          <div
            style={{
              borderRadius: 'calc(var(--sp-xxs)*2)',
              background: `linear-gradient(135deg, ${whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)'} 0%, ${whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)'}dd 100%)`,
              border: 'none',
              fontWeight: '600',
              fontSize: 'calc(var(--fs-xs)*1.32075)',
              color: '#fff',
              textTransform: 'capitalize',
              textAlign: 'center',
              width: 'calc(var(--fs-hero)*3.349057)',
              cursor: 'pointer',
              position: 'relative',
              boxShadow: `0 8px 20px ${whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)'}40`,
              transition: 'all 0.3s ease',
              padding: 'calc(var(--sp-md2)*1.886792) 0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = `0 12px 28px ${whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)'}60`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = `0 8px 20px ${whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)'}40`;
            }}>
            {translate('upload')}
            <input
              id="logo-upload"
              ref={fileInputRef}
              onChange={onFileUpload}
              style={{
                position: 'absolute',
                left: 0,
                width: '100%',
                opacity: 0,
                padding: 0,
                cursor: 'pointer',
                height: '100%'
              }}
              type="file"
              name="filename"></input>
          </div>
          <button
            style={{
              borderRadius: 'calc(var(--sp-xxs)*2)',
              background: '#FFFFFF',
              border: '1.5px solid #E5E7EB',
              fontWeight: '600',
              fontSize: 'calc(var(--fs-xs)*1.32075)',
              color: '#404040',
              textTransform: 'capitalize',
              textAlign: 'center',
              width: 'calc(var(--fs-hero)*3.349057)',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)',
              transition: 'all 0.3s ease',
              padding: 'calc(var(--sp-md2)*1.698113) 0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#F9FAFB';
              e.currentTarget.style.borderColor = '#D1D5DB';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.10)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#FFFFFF';
              e.currentTarget.style.borderColor = '#E5E7EB';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.06)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            onClick={handlePreviewImg}>
            {translate('preview')}
          </button>
        </div>
      </div>
      {sideBanner && (
        <div
          style={{
            margin: 'calc(var(--sp-md2)*1.88679) 0',
            display: 'flex',
            flexDirection: 'column'
          }}>
          <SubHeader label="colorScheme" />
          <div style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-xs)*1)' }}>
            <PaletteIcon style={{ fontSize: 'calc(var(--fs-xs)*1.50943)', color: '#4F4F4F' }} />
            <span
              style={{
                fontWeight: '600',
                color: '#4F4F4F',
                fontSize: 'calc(var(--fs-xs)*1.32075)',
                lineHeight: 'var(--sp-lg)'
              }}>
              {translate('choosePrimaryColorForSideBanner')}
            </span>
          </div>
          <div
            style={{
              margin: 'calc(var(--sp-lg)*1.41509) 0 var(--sp-md2) 0',
              display: 'flex'
            }}>
            <div
              style={{
                height: 'calc(var(--fs-hero)*7.311320)',
                width: 'calc(var(--fs-hero)*5.6603774)'
              }}>
              <SketchPicker
                onChange={(color) => {
                  setSideBannerColor(color.rgb);
                }}
                color={sideBannerColor}
              />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%'
              }}>
              <div
                style={{
                  height: 'calc(var(--fs-hero)*7.311320)',
                  width: '45%',
                  maxWidth: 'calc(var(--fs-hero)*5.6603774)',
                  backgroundColor: `rgba(${r}, ${g}, ${b}, ${a})`,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: '700',
                  fontSize: 'calc(var(--fs-xs)*1.509434)',
                  lineHeight: 'var(--sp-lg)',
                  border: `1px solid rgba(${complement(r, g, b)}, 1)`,
                  color: `rgba(${complement(r, g, b)}, 1)`
                }}>
                {translate('example')}
              </div>
            </div>
          </div>
        </div>
      )}
      {topBanner && (
        <div
          style={{
            margin: 'calc(var(--sp-md2)*1.88679) 0',
            display: 'flex',
            flexDirection: 'column',
            borderTop: '1px solid rgba(229, 231, 235, 1)',
            paddingTop: 'calc(var(--sp-lg)*1.41509)'
          }}>
          {/* <SubHeader /> */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-xs)*1)' }}>
            <PaletteIcon style={{ fontSize: 'calc(var(--fs-xs)*1.50943)', color: '#4F4F4F' }} />
            <span
              style={{
                fontWeight: '600',
                color: '#4F4F4F',
                fontSize: 'calc(var(--fs-xs)*1.32075)',
                lineHeight: 'var(--sp-lg)'
              }}>
              {translate('choosePrimaryColorForTopBanner')}
            </span>
          </div>
          <div
            style={{
              margin: 'calc(var(--sp-lg)*1.41509) 0 var(--sp-md2) 0',
              display: 'flex'
            }}>
            <div
              style={{
                height: 'calc(var(--fs-hero)*7.311320)',
                width: 'calc(var(--fs-hero)*5.6603774)'
              }}>
              <SketchPicker
                onChange={(color) => {
                  setTopBannerColor(color.rgb);
                }}
                color={topBannerColor}
              />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                alignItems: 'center'
              }}>
              <div
                style={{
                  height: 'calc(var(--fs-hero)*1.415094)',
                  maxWidth: 'calc(var(--fs-hero)*10.613208)',
                  width: '80%',
                  backgroundColor: `rgba(${r1}, ${g1}, ${b1}, ${a1})`,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: '700',
                  fontSize: 'calc(var(--fs-xs)*1.509434)',
                  lineHeight: 'var(--sp-lg)',
                  border: `1px solid rgba(${complement(r1, g1, b1)}, 1)`,
                  color: `rgba(${complement(r1, g1, b1)}, 1)`
                }}>
                {translate('example')}
              </div>
            </div>
          </div>
        </div>
      )}
      {background && (
        <div
          style={{
            margin: 'calc(var(--sp-md2)*1.88679) 0',
            display: 'flex',
            flexDirection: 'column',
            borderTop: '1px solid rgba(229, 231, 235, 1)',
            paddingTop: 'calc(var(--sp-lg)*1.41509)'
          }}>
          {/* <SubHeader /> */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-xs)*1)' }}>
            <PaletteIcon style={{ fontSize: 'calc(var(--fs-xs)*1.50943)', color: '#4F4F4F' }} />
            <span
              style={{
                fontWeight: '600',
                color: '#4F4F4F',
                fontSize: 'calc(var(--fs-xs)*1.32075)',
                lineHeight: 'var(--sp-lg)'
              }}>
              {translate('chooseBackgroundColor')}
            </span>
          </div>
          <div
            style={{
              margin: 'calc(var(--sp-lg)*1.41509) 0 var(--sp-md2) 0',
              display: 'flex'
            }}>
            <div
              className="color-picker-wrapper"
              style={{
                height: 'calc(var(--fs-hero)*7.311320)',
                width: 'calc(var(--fs-hero)*5.6603774)'
              }}>
              <SketchPicker
                onChange={(color) => {
                  setBackgroundColor(color.rgb);
                }}
                color={backgroundColor}
                styles={{
                  body: { height: '100%', width: '100%' }
                }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                alignItems: 'center'
              }}>
              <div
                style={{
                  height: 'calc(var(--fs-hero)*7.07547)',
                  width: '80%',
                  maxWidth: 'calc(var(--fs-hero)*10.613208)',
                  backgroundColor: `rgba(${r2}, ${g2}, ${b2}, ${a2})`,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: '700',
                  fontSize: 'calc(var(--fs-xs)*1.509434)',
                  lineHeight: 'var(--sp-lg)',
                  border: `1px solid rgba(${complement(r2, g2, b2)}, 1)`,
                  color: `rgba(${complement(r2, g2, b2)}, 1)`
                }}>
                {translate('example')}
              </div>
            </div>
          </div>
        </div>
      )}
      {button && (
        <div
          style={{
            margin: 'calc(var(--sp-md2)*1.88679) 0',
            display: 'flex',
            flexDirection: 'column',
            borderTop: '1px solid rgba(229, 231, 235, 1)',
            paddingTop: 'calc(var(--sp-lg)*1.41509)'
          }}>
          {/* <SubHeader /> */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-xs)*1)' }}>
            <PaletteIcon style={{ fontSize: 'calc(var(--fs-xs)*1.50943)', color: '#4F4F4F' }} />
            <span
              style={{
                fontWeight: '600',
                color: '#4F4F4F',
                fontSize: 'calc(var(--fs-xs)*1.32075)',
                lineHeight: 'var(--sp-lg)'
              }}>
              {translate('chooseButtonColor')}
            </span>
          </div>
          <div
            style={{
              margin: 'calc(var(--sp-lg)*1.41509) 0 var(--sp-md2) 0',
              display: 'flex'
            }}>
            <div
              style={{
                height: 'calc(var(--fs-hero)*7.311320)',
                width: 'calc(var(--fs-hero)*5.6603774)'
              }}>
              <SketchPicker
                onChange={(color) => {
                  setButtonColor(color.rgb);
                }}
                color={buttonColor}
              />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                alignItems: 'center'
              }}>
              <div
                style={{
                  height: 'calc(var(--fs-hero)*1.415094)',
                  maxWidth: 'calc(var(--fs-hero)*5.660377)',
                  width: '50%',
                  backgroundColor: `rgba(${r3}, ${g3}, ${b3}, ${a3})`,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: '700',
                  fontSize: 'calc(var(--fs-xs)*1.509434)',
                  lineHeight: 'var(--sp-lg)',
                  border: `1px solid rgba(${complement(r3, g3, b3)}, 1)`,
                  color: `rgba(${complement(r3, g3, b3)}, 1)`,
                  borderRadius: 'var(--sp-xxs)'
                }}>
                {translate('example')}
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        style={{
          margin: 'calc(var(--sp-lg)*4.71698) 0 calc(var(--sp-md2)*1.88679) 0',
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%'
        }}>
        <button
          style={{
            borderRadius: 'calc(var(--sp-xxs)*2)',
            background: '#fff',
            border: '1px solid #6B7280',
            fontWeight: '600',
            fontSize: 'calc(var(--fs-xs)*1.32075)',
            color: '#404040',
            textTransform: 'uppercase',
            textAlign: 'center',
            width: '45%',
            cursor: 'pointer',
            padding: 'calc(var(--sp-md2)*1.415094)'
          }}
          onClick={handleCancel}>
          {cancelLoading && <CustomSpinner size={resolveCssVarValue('--fs-xs') * 1.886792} />}
          {!cancelLoading && clearedNotes.length > 0 ? clearedNotes : translate('reset')}
        </button>
        <button
          style={{
            borderRadius: 'calc(var(--sp-xxs)*2)',
            background: `${
              whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)'
            }`,
            border: '1px solid rgba(255, 255, 255, 0.52)',
            fontWeight: '600',
            fontSize: 'calc(var(--fs-xs)*1.32075)',
            color: '#fff',
            textTransform: 'uppercase',
            textAlign: 'center',
            width: '45%',
            cursor: 'pointer',
            padding: 'calc(var(--sp-md2)*1.415094)'
          }}
          onClick={() => {
            onPreview();
          }}
          disabled={disable}>
          {translate('preview')}
        </button>
      </div>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar
          style={{ backgroundColor: '#fff', boxShadow: 'none' }}
          sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon style={{ color: '#000', fontSize: 'calc(var(--fs-xl)*1.32075)' }} />
            </IconButton>
          </Toolbar>
          {/* <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        Sound
                        </Typography> */}
        </AppBar>
        <div
          style={{
            width: '100%',
            height: '90%',
            display: 'flex',
            justifyContent: 'center'
          }}>
          <img
            src={previewImg && imageUrl(previewImg)}
            alt="logo"
            style={{
              width: 'unset',
              height: 'auto',
              objectFit: 'none'
            }}
          />
        </div>
      </Dialog>
      <Modal open={isEditorOpen} onClose={handleCloseEditor}>
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <div
            style={{
              width: '60%',
              minHeight: 'calc(var(--fs-hero)*9.433962)',
              position: 'relative',
              background: '#000',
              padding: 'calc(var(--sp-md2)*1)'
            }}>
            <ImageEditor
              img={logoImage}
              setCroppedImage={handleCroppedImage}
              handleCloseEditor={handleCloseEditor}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default ThemeDesign;
